import ScheduleAppointment from "./ScheduleAppointment";

export default ScheduleAppointment;
